type Status = {
  percentComplete?: number;
  label: string;
  color: string;
  basic: boolean;
  keyRank: number;
};

const status: Status = {
  color: "",
  label: "",
  basic: false,
  keyRank: 0,
};

export type { Status };

export { status };
